import React from "react"
import { useSelector } from "react-redux"

import { formatMoney } from "@/helpers/money"
import { displayPrecision } from "@/onboarding/features/product/helpers"
import { getProductNetCurrencyCode } from "@/onboarding/features/product/selectors"

const RateDisplay = ({
  amount,
  showPrevious = false,
  currencyCode = undefined,
}: {
  amount: number
  showPrevious?: boolean
  currencyCode?: string
}): JSX.Element => {
  const netCurrency = useSelector(getProductNetCurrencyCode)
  const currency = currencyCode || netCurrency
  const displayedAmount = displayPrecision(amount)

  return (
    <span style={showPrevious ? { color: "#00448c" } : undefined}>
      {isNaN(displayedAmount) ? "-" : formatMoney(displayedAmount, currency)}
    </span>
  )
}

export default RateDisplay
